export default __webpack_public_path__ + "content/media/6.a5b494b3.jpg";